// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__28BZ2","filesListContainer":"PosDisputesFiles_filesListContainer__8_twQ","filesButton":"PosDisputesFiles_filesButton__1rBVS"};